import axios from "axios";
import * as URL from "../../helpers/Constants";
import { PMS_DELETE_INCOME_PHARMACY_ID } from "../../helpers/Constants";

export default class PMSIncomeServices {


    static getAllIncomesByPharmacyId(params) {
        return axios.get(`${URL.PMS_GET_ALL_INCOME_BY_PHARMACY_ID}/${params.id}`, {
            params, ...PMSIncomeServices.getAuthHeader()
        })
    }

    static getIncomeByPharmacyIdById(pharmacyId, id) {
        return axios.get(`${URL.PMS_GET_INCOME_BY_PHARMACY_ID_BY_ID}/${pharmacyId}/${id}`, PMSIncomeServices.getAuthHeader())
    }

    static createIncomeByPharmacyId(id, data) {
        return axios.post(`${URL.PMS_CREATE_INCOME_BY_PHARMACY_ID}/${id}`, data, PMSIncomeServices.getAuthHeader())
    }

    static updateIncomeByIdByPharmacyId(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_INCOME_BY_ID_PHARMACY_ID}/${id}/${pharmacyId}`, data, PMSIncomeServices.getAuthHeader())
    }

    static generatePMSIncomeExcelReportByPharmacyId(pharmacyId, params) {
        return axios({
            url: `${URL.PMS_GENERATE_INCOME_EXCEL_REPORT_BY_PHARMACY_ID}/${pharmacyId}`,
            params,
            method: "GET",
            responseType: "blob", // Important,
            ...PMSIncomeServices.getAuthHeaderForFileDownload(),
        });
    }

    static deleteIncomeById(id, pharmacyId) {
        return axios.post(`${URL.PMS_DELETE_INCOME_PHARMACY_ID}/${id}/${pharmacyId}`, {}, PMSIncomeServices.getAuthHeader())
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return { headers: { "Authorization": `Bearer ${accessToken}` } };
    }

    static getAuthHeaderForFileDownload = () => {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Response-Type": "blob",
            },
        };
    };

}